/**
* author: duxin
* date: 2020/4/13
* describe: 手机端显示
*/

<template>
	<div class="menu">
		<i class="iconfont iconmenu" :style="{color: mobileMenuColor}" @click="onShowMenu"></i>
		<transition name="menu">
			<div class="menu-wrap" v-show="show">
				<div class="header-wrap">
					<img style="height: 50px" src="../assets/logo-1.png">
					<i class="el-icon-close" style="font-size: 18px" @click="onShowMenu"></i>
				</div>
				<el-menu @select="onSelect" class="el-menu" background-color="#545c64" text-color="#fff" active-text-color="#e76c5e">
					<template v-for="menu in menus">
						<el-submenu v-if="menu.children" :index="menu.path">
							<template slot="title">
								<span>{{menu.title}}</span>
							</template>
							<el-menu-item v-for="children in menu.children" :index="children.path">{{children.title}}
							</el-menu-item>
						</el-submenu>
						<el-menu-item v-else :index="menu.path">{{menu.title}}</el-menu-item>
					</template>
				</el-menu>
			</div>
		</transition>
	</div>

</template>

<script>
export default {
	name: "kllk-menu-phone",
	props: {
		menus: {
			type: Array,
			default: () => {
				return []
			}
		},
		scrollTop: {
			type: Boolean, //首页导航显示
			default: false,
		},
	},
	data() {
		return {
			show: false,
		}
	},
	computed: {
		mobileMenuColor() {
			return this.scrollTop ? '#fff' : '#409EFF'
		}
	},
	methods: {
		onShowMenu() {
			this.show = !this.show
		},
		onSelect(index) {
			if (index) {
				this.$router.push(index);
			} else {
				this.menus[this.menus.length - 1].call();
			}
			this.show = false;
		}
	}
}
</script>

<style lang="less" scoped>
.menu {
}

.menu-wrap {
	position: fixed;
	top: 0;
	right: 0;
	width: 100%;
	background-color: #545c64;
	height: 100%;
	overflow: auto;

	.header-wrap {
		display: flex;
		justify-content: space-between;
		padding: 0 15px;
		align-items: center;
		color: white;

		img {
			height: 50px;
		}
	}

	.el-menu {
		width: 80%;
		margin-left: 10%;
		border-right: none;
	}
}

.menu-enter {
	transform: translateX(100%);
}

.menu-enter-active {
	transition: transform 0.5s;
}

.menu-leave-active {
	transform: translateX(100%);
	transition: transform 0.5s;
}
</style>